import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { NotifierService } from '@portal/shared/ui/notifier/src';
import { ToastService } from '@portal/shared/ui/toast';

declare const $localize;
@Component({
    selector: 'portal-copy-to-clipboard',
    templateUrl: './copy-to-clipboard.component.html',
    standalone: false
})
export class CopyToClipboardComponent {
  @Input() valueToCopy: string;
  @Input() dataE2eId: string;
  @Input() useNotifierForToast = false;
  @Input() buttonConfig: {
    text?: string;
    title: string;
    class: string;
    iconClass?: string;
  };
  @Input() copyMessage?: string;
  @ViewChild('focusButton', { read: ElementRef }) focusButton: ElementRef<HTMLButtonElement>;

  constructor(public toastService: ToastService, private notifierService: NotifierService) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.preventDefault();
    if (!this.valueToCopy) {
      return null;
    }
    navigator.clipboard
      .writeText(this.valueToCopy.toString())
      .then(() => {
        if (this.useNotifierForToast) {
          this.notifierService.toast(
            this.copyMessage
              ? this.copyMessage
              : $localize`Successfully copied ${this.valueToCopy} to clipboard!`,
          );
        } else {
          this.toastService.showToast(
            this.copyMessage
              ? this.copyMessage
              : $localize`Successfully copied ${this.valueToCopy} to clipboard!`,
          );
        }
      })
      .catch(() => {});
  }
}
